import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Buttons, FlexContainer, Text, Inputs } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { setUserInfoAction } from 'Store/modules/auth/actions';
import {
  hideModalAction,
  setIsLoadingAction,
  setIsNotLoadingAction,
} from 'Store/modules/app/actions';
import useTranslation from 'Hooks/useTranslation';
import { useFetchSaveUserphone } from 'Containers/PhoneScreen/hooks';

const UpdatePhone = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.ACCOUNT);
  const dispatch = useDispatch();
  const [phone, setPhone] = useState('');
  const [isValid, setIsValid] = useState(false);
  const closeModal = (): void => {
    dispatch(hideModalAction());
    dispatch(setIsNotLoadingAction());
  };
  const { mutate, isLoading } = useFetchSaveUserphone({
    onHideModal: closeModal,
  });

  useEffect(() => {
    if (isLoading) {
      dispatch(setIsLoadingAction());
    }
  }, [isLoading]);

  const handleSubmit = (): void => {
    mutate(phone);
    dispatch(setUserInfoAction({ user: { phone } }));
  };
  return (
    <FlexContainer direction="column" gap="dimension_16">
      <Text type="headline" size="L_S_S" color="dark">
        {t('UpdatePhone.title')}
      </Text>
      <Inputs.Phone
        value={phone}
        placeholder="(1) 483 1212891"
        defaultCountry="MX"
        onChange={(value, error) => {
          setPhone(value);
          setIsValid(!error);
        }}
        id="phoneInput"
        hasError={Boolean(phone && !isValid)}
        errorMsg={t('UpdatePhone.Input.error')}
      />
      <Buttons.Classic
        mode="success"
        size="m"
        label={t('UpdatePhone.CTA')}
        fullWidth
        disabled={!isValid}
        onClick={handleSubmit}
        testID="signInSubmit"
      />
    </FlexContainer>
  );
};

export default UpdatePhone;
